import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { ref: "rootElement" }
const _hoisted_2 = {
  key: 0,
  class: "opPaginationContainer top"
}
const _hoisted_3 = { class: "opSvuotaFiltri" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "opItemsTotal" }
const _hoisted_11 = { class: "opItemsTotalText" }
const _hoisted_12 = {
  class: "mb-4",
  style: {"width":"100%","overflow-x":"auto"}
}
const _hoisted_13 = {
  class: "opTable",
  ref: "tableRoot"
}
const _hoisted_14 = {
  key: 1,
  class: "opPaginationContainer bottom"
}
const _hoisted_15 = { class: "opSvuotaFiltri" }
const _hoisted_16 = { class: "opPaginationNumberContainer" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1)
const _hoisted_22 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "opItemsTotal" }
const _hoisted_24 = { class: "opItemsTotalText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showUpperPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClearFilters && _ctx.onClearFilters(...args)))
            }, " Svuota filtri ")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, " < "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["opPaginationNumber", {selected: _ctx.selectedPage == i}]),
                key: i,
                onClick: ($event: any) => (_ctx.setSelectedPage(i))
              }, _toDisplayString(i), 11, _hoisted_4))
            }), 128)),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, " > "),
            _withDirectives(_createElementVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemsPerPage) = $event))
            }, _hoisted_9, 512), [
              [_vModelSelect, _ctx.itemsPerPage]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode("Totale: "),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.totalItemsCount), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _renderSlot(_ctx.$slots, "default", { data: _ctx.items })
      ], 512)
    ]),
    (_ctx.showLowerPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClearFilters && _ctx.onClearFilters(...args)))
            }, " Svuota filtri ")
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, " < "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["opPaginationNumber", {selected: _ctx.selectedPage == i}]),
                key: i,
                onClick: ($event: any) => (_ctx.setSelectedPage(i))
              }, _toDisplayString(i), 11, _hoisted_17))
            }), 128)),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, " > "),
            _withDirectives(_createElementVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemsPerPage) = $event))
            }, _hoisted_22, 512), [
              [_vModelSelect, _ctx.itemsPerPage]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createTextVNode("Totale: "),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.totalItemsCount), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}